// index.js or main file
import React, { useState,useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Login from './pages/login/login';
import Rules from './pages/rules/rules';
import Game from './pages/game/game';
import DDDUI from "./pages/dddUI/ddd";
import Intro from "./pages/intro/intro";
import UserPage from "./pages/userpage/userpage";
import Host from "./pages/host/host";
import Waiting from "./pages/waiting/waiting";
import Leaderboard from "./pages/leaderboard/leaderboard";    

function usePageBackground() {
  const location = useLocation();

  useEffect(() => {
    const body = document.body;

    body.classList.remove('common-bg');

    switch (location.pathname) {
      case '/':
      case '/login':
        body.classList.add('common-bg');
        break;
      case '/rules':
        body.classList.add('common-bg');
        break;
     
      case '/game':
        body.classList.add('common-bg');
        break;

      case '/intro':
        body.classList.add('common-bg');
        break;

      case '/userpage':
        body.classList.add('common-bg');
        break;

      case '/host':
        body.classList.add('common-bg');
        break;

      case '/waiting':
        body.classList.add('common-bg');
        break;

      case '/leaderboard':
        body.classList.add('common-bg');
        break;

        default:
        break;
    }
  }, [location]); 
}


function App() {
  usePageBackground();
  const navigate = useNavigate();
   
     // Header logo: org API cache, then company URL on user session, then env
     const getInitialImage = () => {
       const org = sessionStorage.getItem("orgData");
       if (org && String(org).trim()) return String(org).trim();
       try {
         const ud = JSON.parse(sessionStorage.getItem("userData") || "null");
         const c = ud?.companyLogoUrl;
         if (typeof c === "string" && c.trim()) return c.trim();
       } catch {
         /* ignore */
       }
       return process.env.REACT_APP_EM_LOGO || "";
     };
   
     // State for header config
     const [headerConfig, setHeaderConfig] = useState({
       imageUrl: getInitialImage(),
       backButtonRedirect: "/", // Default back button
       showBackButton: true,
     });
   
     // Update both image and back button together (ONLY from Login)
     const updateHeader = ({ imageUrl, backButtonRedirect, showBackButton }) => {
       setHeaderConfig((prev) => ({
         imageUrl: imageUrl || prev.imageUrl, // Only update if provided
         backButtonRedirect: backButtonRedirect || prev.backButtonRedirect, // Only update if provided
         showBackButton:
           typeof showBackButton === "boolean"
             ? showBackButton
             : prev.showBackButton,
       }));
   
       // Store image in sessionStorage if provided
       if (imageUrl) sessionStorage.setItem("orgData", imageUrl);
     };
   
   
     const handleBack = () => {
       const { backButtonRedirect } = headerConfig;
   
       if (backButtonRedirect.length > 20) {
         // Open in new tab (External Link)
         window.location.href = backButtonRedirect;
       } else {
         // Internal Navigation
         navigate(backButtonRedirect);
       }
     };
   
  

  return (
<DDDUI
  imageUrl={headerConfig.imageUrl}
  onBack={handleBack}
  showBackButton={headerConfig.showBackButton}
>
      <Routes>
        <Route path="/" element={<Login updateHeader={updateHeader}/>} />
        <Route path="/rules" element={<Rules updateHeader={updateHeader}/>} />
        <Route path="/login" element={<Login updateHeader={updateHeader} />} />
        <Route path="/game" element={<Game updateHeader={updateHeader}/>} />
        <Route path="/intro" element={<Intro updateHeader={updateHeader}/>} />
        <Route path="/userpage" element={<UserPage updateHeader={updateHeader}/>} />
        <Route path="/host" element={<Host updateHeader={updateHeader}/>} />
        <Route path="/waiting" element={<Waiting updateHeader={updateHeader}/>} />
        <Route path="/leaderboard" element={<Leaderboard updateHeader={updateHeader}/>} />
      </Routes>
      </DDDUI>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Performance reporting
reportWebVitals();
